import { Stack, Text, TextInput } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// OS detection function
const isMacOS = () => {
	return navigator.userAgent.toLowerCase().includes("mac");
};

export const TextCopyModal = ({ context, id, innerProps }: ContextModalProps<{ text: string }>) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const [clipboardAvailable, setClipboardAvailable] = useState<boolean>(true);
	const copyKey = isMacOS() ? "⌘+C" : "Ctrl+C";
	const { t } = useTranslation();

	// useEffect(() => {
	// 	const checkClipboardAccess = async () => {
	// 		try {
	// 			const permissionStatus = await navigator.permissions.query({
	// 				name: "clipboard-write" as PermissionName
	// 			});
	// 			setClipboardAvailable(permissionStatus.state === "granted" || permissionStatus.state === "prompt");
	// 		} catch {
	// 			setClipboardAvailable(false);
	// 		}
	// 	};
	//
	// 	void checkClipboardAccess();
	// }, []);

	// const handleCopy = async () => {
	// 	try {
	// 		await navigator.clipboard.writeText(innerProps.text);
	// 		context.closeModal(id);
	// 	} catch (error) {
	// 		log.warn("Failed to copy text:", error);
	// 		inputRef.current?.select();
	// 	}
	// };

	const handleTextClick = () => {
		inputRef.current?.select();
	};

	return (
		<Stack gap="md">
			<Text>{t("textcopymodal.title")}</Text>
			<TextInput
				ref={inputRef}
				value={innerProps.text}
				readOnly
				onClick={handleTextClick}
				styles={(theme) => ({
					input: {
						cursor: "pointer",
						backgroundColor: theme.colors.gray[0],
						border: `1px solid ${theme.colors.gray[3]}`,
						padding: "12px",
						fontSize: theme.fontSizes.sm,
						minHeight: "80px",
						whiteSpace: "pre-wrap",
						"&:focus": {
							borderColor: theme.colors.blue[5]
						}
					}
				})}
			/>
			<Text size="xs" c="orange" ta="center">
				<>{t("textcopymodal.copytext", { copyKey })}</>
			</Text>
			{/*{clipboardAvailable && (*/}
			{/*	<Button onClick={handleCopy} fullWidth>*/}
			{/*		Copy to Clipboard*/}
			{/*	</Button>*/}
			{/*)}*/}
		</Stack>
	);
};
